var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.typeDescriptionKey)?_c('Banner',{staticClass:"type-banner mb-20 mt-0",attrs:{"color":"info","closable":true,"label-key":_vm.typeDescriptionKey},on:{"close":_vm.hideTypeDescription}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }